import { PropsWithChildren } from 'react'

import { TAbsoluteLocale } from '@src/config/i18n.config'

import { StatsigBrowserProvider } from './statsig-provider.browser'
import { StatsigServerProvider } from './statsig-provider.server'
import { StatsigUserAgnosticProvider } from './statsig-user-agnostic'
import { getStatsigUser } from './statsig.helpers'

import type { StatsigServerProps } from './statsig.types'

type IsomorphicStatsigProvider = PropsWithChildren<{
  statsigServerProps: StatsigServerProps | null | undefined
  locale: TAbsoluteLocale
}>

export function IsomorphicStatsigProvider({ children, statsigServerProps, locale }: IsomorphicStatsigProvider) {
  if (statsigServerProps) {
    return <StatsigServerProvider statsigServerProps={statsigServerProps}>{children}</StatsigServerProvider>
  }

  const statsigUser = getStatsigUser(locale)
  if (statsigUser) {
    return <StatsigBrowserProvider statsigUser={statsigUser}>{children}</StatsigBrowserProvider> //
  }

  return <StatsigUserAgnosticProvider>{children}</StatsigUserAgnosticProvider> //default Provider for Server
}
